import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { createStandardPublicClientApplication, EventType } from "@azure/msal-browser";
import { config } from "./authConfig";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { theme } from "./Common/UI/styles/theme";

createStandardPublicClientApplication(config.msalConfig).then((msalInstance) => {
  // Default to using the first account if no account is active on page load
  if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
    // Account selection logic is app dependent. Adjust as needed for different use cases.
    msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
  }

  // Optional - This will update account state if a user signs in from another tab or window
  msalInstance.enableAccountStorageEvents();

  msalInstance.addEventCallback((event) => {
    //@ts-ignore
    if (
      event.eventType === EventType.LOGIN_SUCCESS &&
      //@ts-ignore
      event.payload?.account
    ) {
      //@ts-ignore
      const account = event.payload.account;
      msalInstance.setActiveAccount(account);
    }
  });

  const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

  root.render(
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App instance={msalInstance} />
    </ThemeProvider>
  );
});
